import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, DateTimeField, Field } from '../../../commons/DataTable';
import ContractEONType from '../../../commons/DataTable/ContractEONType';
import EnergyContractsActionsField from './EnergyContractsActionsField';

function EnergyContractsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  handleFileListViewEnergyContract,
}) {
  const [t] = useTranslation();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <ContractEONType title="Nome prodotto" source="product_name" />
      <Field title="POD/PDR" source="pod_pdr" className="text-center" />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        className="text-center"
      />
      <Field
        title="Codice Fiscale Fornitore"
        source="supplier.fiscalCode"
        className="text-center"
      />
      <DateTimeField
        title="Data stipula"
        source="contract_signing_date"
        format="DD/MM/YYYY"
      />
      <EnergyContractsActionsField
        title="Documento"
        handleFileListView={handleFileListViewEnergyContract}
      />
    </DataTable>
  );
}

export default EnergyContractsTable;
